var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.isDark,"id":"app"}},[_c('v-content',{staticClass:"main",attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs1":""}},[(_vm.auth)?_c('v-menu'):_vm._e()],1)],1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }